module.exports = __webpack_public_path__ + "img/logo.e5d07c68.png";